import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Wrench } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        if (res.data.token) {
          localStorage.setItem("auth_token", res.data.token);
        }
        setUser(res.data.user);
        const u = res.data.user;
        // Clean hash
        window.history.replaceState(null, "", window.location.pathname);
        if (!u.role) navigate("/onboarding", { state: { user: u } });
        else navigate(u.role === "shop" ? "/shop" : "/owner", { state: { user: u } });
      } catch (e) {
        setErr("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-6">
      <div className="w-12 h-12 bg-[#FF3B30] flex items-center justify-center animate-pulse">
        <Wrench className="w-6 h-6 text-white" strokeWidth={2.5} />
      </div>
      <div className="label-eyebrow">{err || "FINALIZING SESSION..."}</div>
    </div>
  );
}
